import { render, staticRenderFns } from "./studentsEditDataFamily.vue?vue&type=template&id=256ae1d2&scoped=true&"
import script from "./studentsEditDataFamily.vue?vue&type=script&lang=js&"
export * from "./studentsEditDataFamily.vue?vue&type=script&lang=js&"
import style0 from "./studentsEditDataFamily.vue?vue&type=style&index=0&id=256ae1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ae1d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VContainer,VFadeTransition,VForm,VIcon,VProgressCircular,VRow,VSelect,VTabItem,VTextField,VTextarea})
